// src/components/AdvancedSearch.js
import React, { useState,useRef, useEffect } from 'react';
import { Form, Input, Button, Row, Col, Select } from 'antd';
import 'bootstrap-icons/font/bootstrap-icons.css';

const AdvancedSearch = ({ onSearch }) => {
    const [departments, setDepartments] = useState([]);
    const [categories, setCategories] = useState([]);
    const [selectedDepartment, setSelectedDepartment] = useState('');
    const [selectedCategory, setSelectedCategory] = useState('');
    const [isLoadingDepartments, setIsLoadingDepartments] = useState(false);
    const [isLoadingCategories, setIsLoadingCategories] = useState(false);
    
    // Fetch departments on component mount
    useEffect(() => {
        fetchDepartments();
    }, []);
    
    // Fetch categories when department changes
    useEffect(() => {
        if (selectedDepartment) {
            fetchCategories(selectedDepartment);
        } else {
            setCategories([]);
            setSelectedCategory('');
        }
    }, [selectedDepartment]);
    
    const fetchDepartments = async () => {
        setIsLoadingDepartments(true);
        try {
            const response = await fetch('https://live.jeyaagency.com/api/department');
            const data = await response.json();
            console.log(data);
            if (data && data.departments) {
                setDepartments(data.departments);
            }
        } catch (error) {
            console.error('Error fetching departments:', error);
        } finally {
            setIsLoadingDepartments(false);
        }
    };
    
    const fetchCategories = async (departmentId) => {
        if (!departmentId) return;
        
        setIsLoadingCategories(true);
        try {
            const response = await fetch(`https://live.jeyaagency.com/api/categories?parent_id=${departmentId}`);
            const data = await response.json();
            if (data && data.categories) {
                console.log(data.categories);
                setCategories(data.categories);
            }
        } catch (error) {
            console.error('Error fetching categories:', error);
        } finally {
            setIsLoadingCategories(false);
        }
    };
    
    const handleDepartmentChange = (value) => {
        setSelectedDepartment(value);
        setSelectedCategory(''); // Reset category when department changes
    };
    
    const handleCategoryChange = (value) => {
        setSelectedCategory(value);
    };
    
    const handleAdvancedSearch = (values) => {
        const { title = '', author = '', publisher = '', isbn = '', department = '', category = '' } = values;
        onSearch(
            `title=${title}&author=${author}&publisher=${publisher}&isbn=${isbn}&department=${department}&category=${category}`
        );
    };

    const [form] = Form.useForm();
    // Expose ref for App.js
    useEffect(() => {
        window.advancedSearchRef = form;
        return () => { window.advancedSearchRef = null; };
    }, [form]);

    return (
        <Form form={form} layout="vertical" onFinish={handleAdvancedSearch} className="mb-4">            <div className="advanced-search-container p-3 border rounded bg-light">
                <Row gutter={[12, 12]} align="middle" className="mb-2">
                    <Col xs={24} md={6}>
                        <Form.Item name="title" noStyle>
                            <Input placeholder="Title" allowClear />
                        </Form.Item>
                    </Col>
                    <Col xs={24} md={6}>
                        <Form.Item name="author" noStyle>
                            <Input placeholder="Author" allowClear />
                        </Form.Item>
                    </Col>
                    <Col xs={24} md={6}>
                        <Form.Item name="publisher" noStyle>
                            <Input placeholder="Publisher" allowClear />
                        </Form.Item>
                    </Col>
                    <Col xs={24} md={6}>
                        <Form.Item name="isbn" noStyle>
                            <Input placeholder="ISBN" allowClear />
                        </Form.Item>
                    </Col>
                </Row>
                <Row gutter={[12, 12]}>
                    <Col xs={24} md={12}>
                        <Form.Item label="Department" name="department">
                            <Select
                                showSearch
                                placeholder="Department"
                                onChange={handleDepartmentChange}
                                loading={isLoadingDepartments}
                                allowClear
                                filterOption={(input, option) =>
                                    (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
                                }
                                options={departments.map(dept => ({ value: dept.id, label: dept.department }))}
                            />
                        </Form.Item>
                    </Col>
                    <Col xs={24} md={12}>
                        <Form.Item label="Category" name="category">
                            <Select
                                showSearch
                                placeholder={selectedDepartment ? "Category" : "Select department first"}
                                onChange={handleCategoryChange}
                                loading={isLoadingCategories}
                                disabled={!selectedDepartment || isLoadingCategories}
                                allowClear
                                filterOption={(input, option) =>
                                    (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
                                }
                                options={categories.map(cat => ({ value: cat.id, label: cat.name }))}
                            />
                        </Form.Item>
                    </Col>
                </Row>
                <div className="text-end mt-2">
                    <Button type="primary" htmlType="submit" shape="round" icon={<i className="bi bi-search me-1"></i>}>
                        Search
                    </Button>
                </div>
            </div>
        </Form>
    );
};

export default AdvancedSearch;
